import { useQuery } from "@apollo/client";

import {
    type GoogleProtobufTimestampInput,
    MetricField,
    MyLensesAssetType,
    ReportingGranularity,
    ReportingSortDirection,
} from "../../gql-generated/types";
import { type ApolloResult } from "../../shared/models";
import { type GetOrganicStatsQuery, type GetOrganicStatsQueryVariables, getOrganicStats } from "../api/queries";
import { generateFieldsList } from "../generators";

import { useLensBreakdownAssetQueryParams } from "./useLensBreakdownAssetQueryParams";

export const useLensUniquesTotalQuery = (
    endTime: GoogleProtobufTimestampInput | null,
    startTime: GoogleProtobufTimestampInput | null,
): ApolloResult<{ data: GetOrganicStatsQuery | undefined }> => {
    const statsParams = useLensBreakdownAssetQueryParams();

    const { loading, error, data } = useQuery<GetOrganicStatsQuery, GetOrganicStatsQueryVariables>(getOrganicStats, {
        skip: endTime === null || startTime === null,
        variables: {
            granularity: ReportingGranularity.Day,
            fieldsList: generateFieldsList([MetricField.LensDauOverWau, MetricField.LensDauOverMau]),
            assetType: MyLensesAssetType.User,
            ...statsParams,
            startTime,
            endTime,
            sortBy: MetricField.MetricFieldUnset,
            sortDirection: ReportingSortDirection.SortDirectionUnset,
            limit: 0,
        },
    });

    return { loading, error, data };
};
